import {
  hasCompleteQueryData,
  throwOnQueryError,
} from 'ZalamoLibrary/src/lib/core/graphql/complete-query-data';

import { ReplaySubject, filter, map, of, pipe, pluck, switchMap } from 'rxjs';

import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ChangeDetectionStrategy,
} from '@angular/core';
import { GetQuickCoverGQL } from 'ZalamoLibrary/src/lib/ui/quick-cover/graphql';
import { ZalamoObject } from 'Upload/upload/graphql';

import { RxjsOperators } from 'ZalamoLibrary/src/lib/core/operators/RxjsOperators';
import { GetImageUrlService } from 'ZalamoLibrary/src/lib/core/image/image-loader/get-image-url.service';

@Component({
  selector: 'lib-quick-cover',
  templateUrl: './quick-cover.component.html',
  styleUrls: ['./quick-cover.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class QuickCoverComponent implements OnInit, OnChanges {
  @Input() context: ZalamoObject;
  @Input() contextId: string;
  current$ = new ReplaySubject<{ context: ZalamoObject; contextId: string }>(1);
  currentHeight$ = new ReplaySubject(1);
  link$ = this.current$.pipe(
    switchMap(({ context, contextId }) =>
      this.getQuickCoverGQL
        .watch(
          { variables: { context, contextId } },
          // {
          //   fetchPolicy: 'network-only',
          // }
        )
        .valueChanges.pipe(
          throwOnQueryError,
          filter(hasCompleteQueryData),
          map((result) => result.data['quickCover']),
        ),
    ),
  );
  @Input() maxSize = 2048;
  @HostBinding('class.hidden') hidden = true;
  coverDetails$ = this.link$.pipe(
    pluck('cover'),
    RxjsOperators.filterTruthy(),
    switchMap((cover) => {
      if (cover?.file) {
        this.hidden = false;
        this.cd.detectChanges();
        return this.imageLoader
          .publicImage(cover.file, this.maxSize, this.maxSize)
          .pipe(
            map((url) => ({
              url,
              point: { x: cover.x, y: cover.y },
              ...cover,
            })),
          );
      }
      return of(null);
    }),
  );

  constructor(
    private getQuickCoverGQL: GetQuickCoverGQL,
    private imageLoader: GetImageUrlService,
    private el: ElementRef,
    private cd: ChangeDetectorRef,
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    this.current$.next({
      context: changes.context.currentValue,
      contextId: changes.contextId.currentValue,
    });
  }

  ngOnInit(): void {
    this.currentHeight$.next(
      this.el.nativeElement.getBoundingClientRect().width,
    );
  }
}
